/**
 * Registra il service worker (public/sw.js) che rende il portale installabile.
 * Solo in produzione, dopo il load, mai bloccante: un errore non deve toccare l'app.
 * Il service worker non mette in cache nulla se non la pagina «offline» (vedi sw.js).
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return
  const register = () => {
    try {
      navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => { /* non bloccante */ })
    } catch { /* non bloccante */ }
  }
  if (document.readyState === 'complete') register()
  else window.addEventListener('load', register, { once: true })
}
